import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "../../../../../utils/lazyImportRouteComponent"

export type Tab = "start" | "roles" | "activities"

export const Route = createFileRoute("/app/art/productions/$id/")({
  component: lazyImportRouteComponent(
    () => import("./-components/ProductionByIdPage"),
    "ProductionByIdPage"
  ),
  validateSearch: (search: { tab: Tab; seasonIds: number[] }) => ({
    tab: search.tab || "start",
    seasonIds: search.seasonIds || [],
  }),
})
